'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
import * as $j_mealorama$002e$002dCourse from "./mealorama.-Course.js";
var $p;
/** @constructor */
function $c_Lmealorama_Course$() {
}
export { $c_Lmealorama_Course$ as $c_Lmealorama_Course$ };
$p = $c_Lmealorama_Course$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_Course$;
/** @constructor */
function $h_Lmealorama_Course$() {
}
export { $h_Lmealorama_Course$ as $h_Lmealorama_Course$ };
$h_Lmealorama_Course$.prototype = $p;
$p.m = (function() {
  return "Course";
});
$p.aSb = (function(x$0) {
  return new $j_mealorama$002e$002dCourse.$c_Lmealorama_Course((x$0.g(0) | 0), x$0.g(1), (x$0.g(2) | 0));
});
var $d_Lmealorama_Course$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_Course$, "mealorama.Course$", ({
  FI: 1,
  d: 1,
  e: 1
}));
export { $d_Lmealorama_Course$ as $d_Lmealorama_Course$ };
var $n_Lmealorama_Course$;
function $m_Lmealorama_Course$() {
  if ((!$n_Lmealorama_Course$)) {
    $n_Lmealorama_Course$ = new $c_Lmealorama_Course$();
  }
  return $n_Lmealorama_Course$;
}
export { $m_Lmealorama_Course$ as $m_Lmealorama_Course$ };
//# sourceMappingURL=mealorama.-Course$.js.map
